import { useEffect, useState } from 'react';
import { useGetApiV1ClassroomdisciplineSharedDisciplines } from '@/shared/api/generated';

/** Opção de disciplina para vínculo (id = `classroomDisciplineId`). */
export interface DisciplinaOption {
  readonly id: string;
  readonly name: string;
}

/**
 * Busca de disciplinas (class-planning shared) por texto, com debounce de 1 s e mínimo de
 * 3 caracteres. Fonte das disciplinas **vinculáveis** no modal em lote — a `key` do
 * `DropDownListViewModel` é o `classroomDisciplineId` enviado ao endpoint de vínculo.
 *
 * @param filter - Texto digitado (default `''`).
 * @param courseId - Filtra por curso, quando informado.
 */
export function useDisciplinesSearchDropdown(filter = '', courseId?: number) {
  const [debouncedFilter, setDebouncedFilter] = useState('');

  useEffect(() => {
    if (filter === '') {
      setDebouncedFilter('');
      return;
    }
    const timer = setTimeout(() => setDebouncedFilter(filter), 1000);
    return () => clearTimeout(timer);
  }, [filter]);

  const isReady = debouncedFilter.length >= 3;

  const { data, isLoading, isSuccess } = useGetApiV1ClassroomdisciplineSharedDisciplines(
    isReady
      ? { Search: debouncedFilter, ...(courseId !== undefined ? { CourseId: courseId } : {}) }
      : undefined,
    { query: { enabled: isReady } },
  );

  const disciplines: readonly DisciplinaOption[] = (data ?? []).map(item => ({
    id: String(item.key ?? ''),
    name: item.value ?? '',
  }));

  return { disciplines, isLoading, isQuerySuccess: isSuccess } as const;
}
